import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import NavigationLinks from './navigation-links'
import './navigation.css'

const Navigation = (props) => {
  return (
    <header data-role="Header" className="navigation-thq-header-elm">
      <div className="navigation-thq-max-width-elm">
        <Link to="/" className="navigation-navlink">
          <img
            src="/logo_colorstranstop-200h.png"
            className="navigation-image"
          />
        </Link>
        <div className="navigation-thq-nav-elm1">
          <NavigationLinks
            link1="Home"
            link3="Portfolio"
            rootClassName="navigation-linksroot-class-name17"
          ></NavigationLinks>
          <a
            href="/contact"
            className="navigation-thq-register-elm1 button-secondary button button-md"
          >
            {props.button}
          </a>
        </div>
        <div data-role="BurgerMenu" className="navigation-thq-burger-menu-elm">
          <svg viewBox="0 0 1024 1024" className="navigation-thq-icon-elm">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div data-role="MobileMenu" className="mobile-menu">
          <div className="navigation-thq-nav-elm2">
            <div className="navigation-thq-container-elm">
              <img
                alt="image"
                src="/logo_colorstranstop-200h.png"
                className="navigation-thq-image-elm"
              />
              <div
                data-role="CloseMobileMenu"
                className="navigation-thq-close-mobile-menu-elm"
              >
                <svg viewBox="0 0 1024 1024" className="navigation-icon2">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <NavigationLinks rootClassName="navigation-linksroot-class-name18"></NavigationLinks>
            <a
              href="/contact"
              className="navigation-thq-register-elm2 button-secondary button button-md"
            >
              {props.button2}
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

Navigation.defaultProps = {
  button: 'Get in touch',
  button2: 'Get in touch',
}

Navigation.propTypes = {
  button: PropTypes.string,
  button2: PropTypes.string,
}

export default Navigation
